import { SeparationReviewSummary, SeparationReviewListResponse } from './pending-reviews.service';

/**
 * Single dummy separation review record for testing
 */
export const DUMMY_SEPARATION_REVIEW: SeparationReviewSummary = {
  documentId: '71a22e3d-4c25-425b-80d9-d779644b868a',
  originalFilename: 'tax-documents-2024.pdf',
  parentDocumentStatus: 'separation_review',
  stepFunctionStatus: 'paused_for_review',
  organization: 'org-12345',
  totalPages: 24,
  childDocumentCount: 3,
  taskTokenCreatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
  taskTokenExpiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
};

/**
 * Array of dummy separation review records for testing list views
 */
export const DUMMY_SEPARATION_REVIEWS: SeparationReviewSummary[] = [
  {
    documentId: '71a22e3d-4c25-425b-80d9-d779644b868a',
    originalFilename: 'tax-documents-2024.pdf',
    parentDocumentStatus: 'separation_review',
    stepFunctionStatus: 'paused_for_review',
    organization: 'org-12345',
    totalPages: 24,
    childDocumentCount: 3,
    taskTokenCreatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    taskTokenExpiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    documentId: 'f3c9d55a-e617-41f4-8283-677d6b2ff433',
    originalFilename: 'invoice-march-2024.pdf',
    parentDocumentStatus: 'separation_review',
    stepFunctionStatus: 'paused_for_review',
    organization: 'org-12345',
    totalPages: 8,
    childDocumentCount: 2,
    taskTokenCreatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    taskTokenExpiresAt: new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    documentId: '2db05721-ba11-418e-a2d7-9707cd057042',
    parentDocumentStatus: 'separation_review',
    stepFunctionStatus: 'paused_for_review',
    organization: 'org-12345',
    totalPages: 42,
    childDocumentCount: 5,
    taskTokenCreatedAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(), // 12 hours ago
    taskTokenExpiresAt: new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString(), // Expiring soon (12 hours)
  },
  {
    documentId: '3460877b-c244-4ac2-b079-5256b0f2b936',
    parentDocumentStatus: 'separation_review',
    stepFunctionStatus: 'paused_for_review',
    organization: 'org-12345',
    totalPages: 16,
    childDocumentCount: 4,
    taskTokenCreatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    taskTokenExpiresAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(), // Expired (1 hour ago)
  },
  {
    documentId: 'a21c7cc5-e4eb-40c4-a844-3e8804da2939',
    originalFilename: 'multipart-scan-2024.pdf',
    parentDocumentStatus: 'separation_review',
    stepFunctionStatus: 'paused_for_review',
    organization: 'org-12345',
    totalPages: 12,
    childDocumentCount: 2,
    taskTokenCreatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    taskTokenExpiresAt: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

/**
 * Dummy response matching the API response structure
 */
export const DUMMY_SEPARATION_REVIEW_RESPONSE: SeparationReviewListResponse = {
  documents: DUMMY_SEPARATION_REVIEWS,
  totalCount: DUMMY_SEPARATION_REVIEWS.length,
};
